import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Nach einem Deployment passen alte, im Browser gecachte JS-Chunks nicht mehr
// zur neuen Version → Klicks/Navigation laufen ins Leere. Einmalig automatisch
// neu laden, statt die Nutzer mit einer kaputten Seite sitzen zu lassen.
const reloadOnStaleChunk = (reason) => {
  const msg = String(reason?.message || reason || "");
  const isChunkError = reason?.name === "ChunkLoadError"
    || /Loading chunk .* failed|ChunkLoadError|Failed to fetch dynamically imported module/i.test(msg);
  if (isChunkError && !sessionStorage.getItem("dh-chunk-reload")) {
    sessionStorage.setItem("dh-chunk-reload", "1");
    window.location.reload();
  }
};
window.addEventListener("error", (e) => reloadOnStaleChunk(e.error || e));
window.addEventListener("unhandledrejection", (e) => reloadOnStaleChunk(e.reason));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
